import '../css/app.css'
import Vue from 'vue'
import Axios from 'axios'
import QS from 'qs'
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon
} from 'vue-simple-accordion'
import VDialogContact from "../vue/VDialogContact.vue";

new Vue({
  el: '#app',
  data () {
    return {
      menu: false,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
      contactStreet: null,
      contactCity: null,
      contactPostCode: null,
      contactNote: null,
      termsAgreed: null,
      formSent: false,
      contactSending: false,
      simpleContactSent: false,
      products: [],
      contactService: null
    }
  },
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    VDialogContact
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu;
    },
    /**
     * Send simple contact form
     */
    submitSimpleContact () {
      Axios.post('/nezavazna-poptavka', QS.stringify({
        contactPhone: this.contactPhone,
      }))
        .then((result) => {
          this.contactPhone = null
          window.location.href = '/dekujeme-za-poptavku'
        })
        .catch((err) => {
          alert('Nastala chyba při odeslání kontaktního formuláře')
          this.simpleContactSent = false
        })
    },
    /**
     * Send contact form
     */
    submitContact() {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.contactSending) return
      this.contactSending = true
      grecaptcha.ready(() => {
        grecaptcha.execute('6LdqfG4qAAAAAK-_T0rAXmj3g5ti3T-SsWGi-o_i', { action: 'submit' }).then((token) => {
          // Send the token along with the form data
          Axios.post('/kontakt', QS.stringify({
            contactName: this.contactName,
            contactPhone: this.contactPhone,
            contactEmail: this.contactEmail,
            contactStreet: this.contactStreet,
            contactCity: this.contactCity,
            contactPostCode: this.contactPostCode,
            contactNote: this.contactNote,
            contactService: this.contactService,
            recaptchaToken: token
          }))
              .then((result) => {
                // Clear form fields and redirect
                this.contactName = null;
                this.contactPhone = null;
                this.contactEmail = null;
                this.contactStreet = null;
                this.contactCity = null;
                this.contactPostCode = null;
                this.contactNote = null;
                this.formSent = true;
                window.location.href = '/dekujeme-za-poptavku';
              })
              .catch((err) => {
                alert('Nastala chyba při odeslání kontaktního formuláře');
                this.formSent = false;
                this.contactSending = false;
              });
        });
      });
    }
  },
  computed: {
    isContactDisabled () {
      return !this.termsAgreed || this.contactSending;
    },
    isSimpleContactDisabled () {
      return !this.contactPhone
    },
  }
})

